import { createApiClient } from 'Network/ApiClient';

export const DrugMedicalGroupAxiosInstance = createApiClient('Drugsmedical/');


